import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LocalStorageService } from 'angular-2-local-storage';
import { HostChangedData } from '../models/hostChangedData';
import { ModuleChangedData } from '../models/moduleChangedData';
import { BrandingTerm } from '../models/branding-term';
import { TranslateService } from '@ngx-translate/core';
import { agilityRiskVersion, languages, storageKeys } from '../agility-risk.constants';

@Injectable({
  providedIn: 'root'
})

export class AgilityRiskEventService {
  private onHostChangedSubject: Subject<any> = new Subject<any>();
  private onModuleChangedSubject: Subject<any> = new Subject<any>();

  get surveyKey(): string {
    return this.storageService.get(storageKeys.surveyKey);
  }

  get version(): string {
    return agilityRiskVersion;
  }

  get surveyUserId(): string {
    return this.storageService.get(storageKeys.surveyUserId);
  }

  constructor(private storageService: LocalStorageService,
              private translationService: TranslateService) {
  }

  onHostChanged(): Observable<HostChangedData> {
    console.log('subscribe to the host app changes');
    return this.onHostChangedSubject.asObservable();
  }

  hostChanged(data: HostChangedData): void {
    console.log('Something changed in the host app');
    this.onHostChangedSubject.next(data);
  }

  onModuleChanged(): Observable<ModuleChangedData> {
    console.log('subscribe to changes in the module');
    return this.onModuleChangedSubject.asObservable();
  }

  moduleChanged(data: ModuleChangedData): void {
    console.log('Something changed in the module');
    this.onModuleChangedSubject.next(data);
  }

  clearStorage(): void {
    this.storageService.clearAll();
  }

  onLanguageChanged(lang: string) {
    if (lang !== this.translationService.currentLang && Object.keys(languages).findIndex(k => languages[k] === lang) > -1) {
      this.translationService.use(lang);
    }
  }

  updateBrandingTerms(lang: string, termsForReplacement: Array<BrandingTerm>): void {
    if (Object.keys(languages).findIndex(k => languages[k] === lang) > -1 && termsForReplacement) {
      this.storageService.set(`${storageKeys.brandingTerms}.${lang}`, termsForReplacement);
      this.translationService.resetLang(lang);
      this.translationService.getTranslation(lang);
    }
  }
}
